var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-view"},_vm._l((_vm.tabs),function(tab,i){return _c('div',{key:i,class:{
		tab: 	true,
		active: _vm.value == tab.value
	},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('input', tab.value)}}},[_vm._v(_vm._s(tab.label))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }